var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClockGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icClockWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guest",
    transform: "translate(-37.000000, -420.000000)",
    fill: "#7bcb45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(5.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icClockWhite",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45971875,6.47133008 L5.92601367,5.32105664 L5.92601367,2.97792773 C5.92601367,2.74233008 5.73557617,2.55189258 5.49997852,2.55189258 C5.26438086,2.55189258 5.07394336,2.74233008 5.07394336,2.97792773 L5.07394336,5.5340957 C5.07394336,5.66828711 5.137,5.79483008 5.24435742,5.87492383 L6.94845508,7.15300781 C7.02513281,7.21052148 7.11461523,7.23821484 7.20364648,7.23821484 C7.33358398,7.23821484 7.46139453,7.1798418 7.5449043,7.06737109 C7.68637891,6.87946875 7.6480293,6.61235352 7.45971875,6.47133008 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0 C2.46711523,0 0,2.46711523 0,5.5 C0,8.53288477 2.46711523,11 5.5,11 C8.53288477,11 11,8.53288477 11,5.5 C11,2.46711523 8.53288477,0 5.5,0 Z M5.5,10.1479512 C2.93745117,10.1479512 0.852048828,8.06254883 0.852048828,5.5 C0.852048828,2.93745117 2.93745117,0.852048828 5.5,0.852048828 C8.06297852,0.852048828 10.1479512,2.93745117 10.1479512,5.5 C10.1479512,8.06254883 8.06254883,10.1479512 5.5,10.1479512 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClockGreen);
export default __webpack_public_path__ + "static/media/icClockGreen.cfcfca503c62cd8a21c4a12045ec7182.svg";
export { ForwardRef as ReactComponent };